module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[39]282.3267c89.woff2";